<!--Copyright (c) Laserfiche.
Licensed under the MIT License. See LICENSE in the project root for license information.-->

<i class="loader"></i>
<span class="lf-loader-text">{{LOADING | async}}</span>
